import MoneyInput from './MoneyInput';
import './MoneyInput.scss';
// import NumberInput from '../NumberInput';

export default MoneyInput
// export default NumberInput
